
export function Config() {
    return {serverUrl: "https://acdademoapialb.adilanalytics.net/dash/api/v1/"}
    //return {serverUrl: "http://ec2-35-173-228-67.compute-1.amazonaws.com:8789/dash/api/v1/"}
}
